import { initializeApp, deleteApp, getApp } from "firebase/app";

function firebaseConfigFunction(appSettings) {
  const { firebaseConfig, gtmId } = appSettings;

  if (firebaseConfig) {
    let app = null;
    try {
      app = initializeApp(firebaseConfig);
    } catch (e) {
      app = getApp();
      deleteApp(app);
      initializeApp(firebaseConfig);
    }
  }

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  const body = document.getElementsByTagName("body")[0];
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gtmId}`;
  script.async = true;
  script.onload = function () {
    window.gtm(window, document, "script", "dataLayer", gtmId);
    gtag("config", gtmId);
  };

  body.appendChild(script);

  // (() => {
  //   const ituneTag = document?.getElementById("apple-itunes-app")?.name;
  //   if (!ituneTag) {
  //     const meta = document.createElement("meta");
  //     meta.name = "apple-itunes-app";
  //     meta.id = "apple-itunes-app";
  //     meta.content = `app-id=` + iosAppId;
  //     document.head.appendChild(meta);
  //   }
  // })();
  return firebaseConfig;
}
export default firebaseConfigFunction;
